module.exports = __webpack_public_path__ + "static/media/excelFile.25ae12a7.svg";